var _defs, _path, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVizrt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448.31 273.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 136h54v137.320313H0Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394 0h54.308594v137H394Zm0 0"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f8971d",
    fillRule: "evenodd",
    d: "M113.9375 99.535156 92.949219 158.875 72.246094 99.535156H50.664063l32.605468 86.636719h18.492188l33.226562-86.636719H113.9375M155.214844 99.617188v86.65625h19.351562v-86.65625h-19.351562M199.5 99.617188l-.015625 17.726562h36.425781l-37.292968 55.472656v13.355469h61.609375v-17.523437h-37.464844l36.667969-55.078125V99.617188H199.5M304.0625 99.589844c-5.613281 0-9.988281.898437-14.398437 5.304687-4.214844 4.210938-6.355469 9.363282-6.355469 15.367188v65.886719h19.324219v-62.917969c0-1.640625.578125-3.003906 1.753906-4.183594.980469-.984375 3.214844-1.742187 5.21875-1.742187h16.148437V99.589844H304.0625M344.675781 73.300781v91.589844c0 5.867188 2.074219 10.945313 6.210938 15.082031 4.332031 4.34375 8.558594 6.199219 14.105469 6.199219h21.269531v-17.46875h-15.878906c-1.597657 0-2.898438-.550781-4.074219-1.6875-1.117188-1.152344-1.675781-2.449219-1.675781-4.066406v-45.640625h21.628906V99.671875h-21.628906V73.300781h-19.957032"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f8971d",
    fillRule: "evenodd",
    d: "M0 136.570313c-.0390625 51.414062 17.324219 98.847656 46.554688 136.75l6.925781-20.464844c-20.546875-30.058594-33.34375-65.804688-35.527344-104.367188L0 136.570313"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f8971d",
    fillRule: "evenodd",
    d: "M448.3125 136.726563C448.359375 85.328125 430.996094 37.871094 401.773438 0l-6.945313 20.433594c20.554688 30.070312 33.359375 65.835937 35.523438 104.371094l17.960937 11.921875"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVizrt);
export default __webpack_public_path__ + "static/media/vizrt.ba685b8f1f078ce4e76dade12898e3f3.svg";
export { ForwardRef as ReactComponent };